import moment from 'moment';

export const formatDuration = (totalMs) => {
  if (!totalMs || totalMs <= 0) return "N/A";
  const totalSeconds = Math.floor(totalMs / 1000);
  const totalHours = totalSeconds / 3600;
  const hours = Math.floor(totalHours);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const decimalDays = (totalHours / 24).toFixed(1);
  return `${hours}h ${minutes}min (${decimalDays} days)`;
};

export const formatTime12 = (date) => {
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};

export const formatMovedToDone = (dateStr, timeStr) => {
  const date = moment(
    `${dateStr} ${timeStr}`,
    [
      'DD/MM/YYYY HH:mm:ss',
      'DD/MM/YYYY HH:mm'
    ],
    true
  );

  if (!date.isValid()) return 'N/A';

  return `${date.format('DD/MM/YYYY')} at ${date.format('hh:mm A')}`;
};

export const parseDurationString = (durationStr) => {
  if (!durationStr || durationStr === "N/A") return 0;

  // If only a number is passed → treat as hours
  if (/^\d+$/.test(durationStr)) {
    const hrs = parseInt(durationStr, 10);
    return hrs * 3600 * 1000;
  }

  // Match formats like: "7 hrs 30 mins", "7h 30m"
  const match = durationStr.match(/(\d+)\s*h(?:rs)?\s*(\d+)?\s*m(?:ins)?/i);
  if (!match) return 0;

  const hrs = parseInt(match[1], 10) || 0;
  const mins = parseInt(match[2], 10) || 0;

  return (hrs * 3600 + mins * 60) * 1000;
};


export const removeNullFields = (obj)=> {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, v]) => v !== null && v !== undefined)
  );
}
export const parseHours = (str) => {
  if (!str || str === 'N/A') return 0;

  const hMatch = str.match(/(\d+)\s*h/);
  return hMatch ? Number(hMatch[1]) : 0;
}
export const formatHours = (num) => {
  if (!num) return '0 hrs 0 mins';
  const hrs = Math.floor(num);
  const mins = Math.round((num - hrs) * 60);
  return `${hrs} hrs ${mins} mins`;
}
const parseDateTime = (dateStr, timeStr) => {
  if (!dateStr) return 0;
  const [day, month, year] = dateStr.split('/');
  const time = timeStr || "00:00:00"; // fallback if no time
  return new Date(`${year}-${month}-${day}T${time}`).getTime();
};
export function sortByMovedDate(cards) {
  return cards.sort((a, b) => {
    return (
      parseDateTime(b.movedDate, b.movedTime) -
      parseDateTime(a.movedDate, a.movedTime)
    );
  });
}


// WEBPACK FOOTER //
// ./src/components/Performance/performanceHelper.js